import { JsonRestApiRequestConfig, makeJsonRestApiRequest } from '../../../httpClient/RestApiService';

const catalogTagsBatchDeleteConfig: JsonRestApiRequestConfig = {
  restApiVersion: '3.9',
  serverWideRequest: false,
  httpMethod: 'DELETE',
  endpoint: 'tags:batchDelete'
};

export type CatalogContentTypesOnWhichTagsCanBeDeleted = 'database' | 'table' | 'column';

export type CatalogTagsBatchDeleteParams = {
  readonly contentType: CatalogContentTypesOnWhichTagsCanBeDeleted;
  readonly itemLuids: ReadonlyArray<string>;
  readonly tagsToRemove: ReadonlyArray<string>;
}

export type CatalogTagsBatchDeleteRequestBody = {
  readonly tagBatch: {
    readonly tags: {
      readonly tag: ReadonlyArray<{
        readonly label: string;
      }>;
    };
    readonly contents: {
      readonly content: ReadonlyArray<{
        readonly contentType: CatalogContentTypesOnWhichTagsCanBeDeleted;
        readonly id: string;
      }>;
    };
  };
}


function mapParamsToBody(params: CatalogTagsBatchDeleteParams): CatalogTagsBatchDeleteRequestBody {
  return {
    tagBatch: {
      tags: {
        tag: params.tagsToRemove.map(tag => ({
          label: tag
        })),
      },
      contents: {
        content: params.itemLuids.map(luid => ({
          contentType: params.contentType,
          id: luid,
        })),
      }
    }
  };
}

export async function callViaApiService(params: CatalogTagsBatchDeleteParams) {
  return makeJsonRestApiRequest<CatalogTagsBatchDeleteRequestBody, {}>({
    config: catalogTagsBatchDeleteConfig,
    request: mapParamsToBody(params),
  });
}
